define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,xml,Query) {

	return declare(Ref, {
		isTabStop: function(/*Context*/ctx, /*Heading*/h) {
			// summary: skip over AggregateInline actions where only dialog is allowed
			return ctx.getNode().MaterialCandidates.length > 0;
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: action will be used for tooltip
			var	ad = this.inherited(arguments);
			if (ad) {
				ad.bTooltip = !this.isTabStop(ctx, h);
			}

			return ad;
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return Action including ViewRef and optionally Filter and FilterView to select defaults

			if (this.isTabStop(ctx, h)) {
				return lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "MaterialCandidates"
					})
				});
			}

			// DE20778
			var query = new Query();
			query.Attr("Active", xml.OP_EQUALS, true);

			return lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "AllMaterials",
					m_url: "centric://APPAREL/Views"
				}),
				m_fixedQuery: query
			});
		}
	});
});